// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Char from "../Data.Char/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ratio from "../Data.Ratio/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as StringParser_CodePoints from "../StringParser.CodePoints/index.js";
import * as StringParser_Combinators from "../StringParser.Combinators/index.js";
import * as StringParser_Parser from "../StringParser.Parser/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var bind = /* #__PURE__ */ Control_Bind.bind(StringParser_Parser.bindParser);
var pure = /* #__PURE__ */ Control_Applicative.pure(StringParser_Parser.applicativeParser);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_List_Types.foldableNonEmptyList);
var reduce = /* #__PURE__ */ Data_Ratio.reduce(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var MBS = function (x) {
    return x;
};
var showMBS = {
    show: function (v) {
        return show(v.m) + ("." + (show(v.b) + ("." + (show(Data_Ratio.numerator(v.s)) + ("/" + show(Data_Ratio.denominator(v.s)))))));
    }
};
var eqMBS = /* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "s";
    }
})(/* #__PURE__ */ Data_Ratio.eqRatio(Data_Eq.eqInt)))()({
    reflectSymbol: function () {
        return "m";
    }
})(Data_Eq.eqInt))()({
    reflectSymbol: function () {
        return "b";
    }
})(Data_Eq.eqInt));
var ascii0 = /* #__PURE__ */ Data_Char.toCharCode("0");
var digit = function (d) {
    return Data_Char.toCharCode(d) - ascii0 | 0;
};
var $$parseInt = /* #__PURE__ */ bind(/* #__PURE__ */ StringParser_Combinators.option("+")(/* #__PURE__ */ StringParser_CodePoints["char"]("-")))(function (signChar) {
    var sign = (function () {
        var $39 = signChar === "-";
        if ($39) {
            return -1 | 0;
        };
        return 1;
    })();
    return bind(StringParser_Combinators.many1(StringParser_CodePoints.anyDigit))(function (dgts) {
        return pure(sign * foldl(function (acc) {
            return function (d) {
                return (10 * acc | 0) + digit(d) | 0;
            };
        })(0)(dgts) | 0);
    });
});
var parseFrac = /* #__PURE__ */ bind($$parseInt)(function (num) {
    return bind(StringParser_Combinators.option(1)(bind(StringParser_CodePoints["char"]("/"))(function () {
        return $$parseInt;
    })))(function (denom) {
        return pure(reduce(num)(denom));
    });
});
var parseMBS = function (str) {
    var v = function (v1) {
        if (Data_Boolean.otherwise) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at ProtoVoices.Common (line 53, column 1 - line 53, column 32): " + [ str.constructor.name ]);
    };
    var $42 = Data_String_Common.split(".")(str);
    if ($42.length === 3) {
        return bind1(Data_Either.hush(StringParser_Parser.runParser($$parseInt)($42[0])))(function (m) {
            return bind1(Data_Either.hush(StringParser_Parser.runParser($$parseInt)($42[1])))(function (b) {
                return bind1(Data_Either.hush(StringParser_Parser.runParser(parseFrac)($42[2])))(function (s) {
                    return pure1({
                        m: m,
                        b: b,
                        s: s
                    });
                });
            });
        });
    };
    return v(true);
};
var parseTime = function (str) {
    return Data_Maybe.maybe(new Data_Either.Left(str))(Data_Either.Right.create)(parseMBS(str));
};
export {
    MBS,
    ascii0,
    digit,
    $$parseInt as parseInt,
    parseFrac,
    parseMBS,
    parseTime,
    eqMBS,
    showMBS
};
